@if (cardInfo(); as cardInfo) {
  <div>
    <glxy-form-field bottomSpacing="none">
      <div class="task-container">
        <button (click)="updateTaskCompletionStatus()" mat-icon-button>
          @if (taskCompleted()) {
            <mat-icon class="completed-task">check_circle</mat-icon>
          } @else {
            <mat-icon class="open-task" [ngClass]="{ 'overdue-task': taskOverdue() }">radio_button_unchecked</mat-icon>
          }
        </button>
        <div class="task-content">
          <div class="title">{{ cardInfo.title }}</div>
          <extended>
            <div class="card-content" [innerHtml]="cardInfo.body | sanitizeHtml"></div>
          </extended>
        </div>
      </div>
    </glxy-form-field>
    <div class="row">
      <ng-container
        [ngTemplateOutlet]="activityData"
        [ngTemplateOutletContext]="{ label: 'ACTIVITY.TASK.TYPE', value: cardInfo.type }"
      ></ng-container>
      <ng-container
        [ngTemplateOutlet]="activityData"
        [ngTemplateOutletContext]="{ label: 'ACTIVITY.TASK.PRIORITY', value: cardInfo.priority }"
      ></ng-container>
    </div>
  </div>
}

<ng-template #activityData let-label="label" let-value="value">
  <div class="col col-xs-12 col-md-4">
    <div class="activity-data-label">
      {{ label | translate }}
    </div>
    <div class="activity-data-value">
      <!-- ng-container necessary so angular interpolation will add empty -->
      @if (value) {
        <ng-container>
          {{ value }}
        </ng-container>
      }
    </div>
  </div>
</ng-template>
